export class UIConfig {
}
UIConfig.touchScrollEnable = true;
UIConfig.mouseWheelEnable = true;
UIConfig.showButtons = true;
UIConfig.popupBgColor = "#000000";
UIConfig.popupBgAlpha = 0.5;
UIConfig.closeDialogOnSide = true;
